import React from 'react';

export default function AaDomainVis(): JSX.Element {
  return (
    <>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 8.01749 21.3148)"
        fill="#5F7B00"
      />
      <g clipPath="url(#clip0_828_55410)">
        <g clipPath="url(#clip1_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 6.0208 9.25339)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 9.49409 14.1481)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 5.69698 10.7405)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 16.8096 33.3151)"
        fill="#DAF972"
      />
      <g clipPath="url(#clip2_828_55410)">
        <g clipPath="url(#clip3_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 14.8129 21.2536)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 18.2862 26.1483)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 14.4891 22.7408)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 63.9825 21.3148)"
        fill="#5F7B00"
      />
      <g clipPath="url(#clip4_828_55410)">
        <g clipPath="url(#clip5_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 65.9792 9.25339)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 62.5059 14.1481)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 66.303 10.7405)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 55.1904 33.3151)"
        fill="#DAF972"
      />
      <g clipPath="url(#clip6_828_55410)">
        <g clipPath="url(#clip7_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 57.1871 21.2536)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 53.7138 26.1483)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 57.5109 22.7408)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 15.8327 15.3147)"
        fill="#005B82"
      />
      <g clipPath="url(#clip8_828_55410)">
        <g clipPath="url(#clip9_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 13.836 3.25323)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 17.3093 8.14792)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 13.5122 4.74039)"
          fill="white"
        />
      </g>
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(1 0 -0.0131528 -0.999913 27.5343 61)"
        fill="#95DAF8"
      />
      <g clipPath="url(#clip10_828_55410)">
        <g clipPath="url(#clip11_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8578 50.0773)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8559 56.0774)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.000311317 1 -1 0 31.7325 51.0773)"
          fill="white"
        />
      </g>
      <path
        d="M28.3533 25.0005L30.812 27.5362C31.1815 27.9172 31.3843 28.4295 31.3759 28.9602L31.2957 34.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(1 0 -0.0131528 -0.999913 27.5343 46.9997)"
        fill="#95DAF8"
      />
      <g clipPath="url(#clip12_828_55410)">
        <g clipPath="url(#clip13_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8578 36.077)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8559 42.0771)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.000311317 1 -1 0 31.7325 37.077)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 24.6248 27.3149)"
        fill="#95DAF8"
      />
      <g clipPath="url(#clip14_828_55410)">
        <g clipPath="url(#clip15_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 22.6281 15.2535)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 26.1013 20.1482)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 22.3043 16.7407)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 56.6617 15.3147)"
        fill="#005B82"
      />
      <g clipPath="url(#clip16_828_55410)">
        <g clipPath="url(#clip17_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 58.6584 3.25323)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 55.1852 8.14792)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 58.9822 4.74039)"
          fill="white"
        />
      </g>
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(-1 0 0.0131528 -0.999913 44.9601 61)"
        fill="#95DAF8"
      />
      <g clipPath="url(#clip18_828_55410)">
        <g clipPath="url(#clip19_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6367 50.0773)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6385 56.0774)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.000311317 1 1 0 40.762 51.0773)"
          fill="white"
        />
      </g>
      <path
        d="M44.1411 25.0005L41.6824 27.5362C41.313 27.9172 41.1101 28.4295 41.1185 28.9602L41.1987 34.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(-1 0 0.0131528 -0.999913 44.9601 46.9997)"
        fill="#95DAF8"
      />
      <g clipPath="url(#clip20_828_55410)">
        <g clipPath="url(#clip21_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6367 36.077)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6385 42.0771)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.000311317 1 1 0 40.762 37.077)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 47.8696 27.3149)"
        fill="#95DAF8"
      />
      <g clipPath="url(#clip22_828_55410)">
        <g clipPath="url(#clip23_828_55410)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 49.8663 15.2535)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 46.3931 20.1482)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 50.1902 16.7407)"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 5.31523 7.90866)"
          />
        </clipPath>
        <clipPath id="clip1_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 6.22141 9.10419)"
          />
        </clipPath>
        <clipPath id="clip2_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 14.1073 19.9089)"
          />
        </clipPath>
        <clipPath id="clip3_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 15.0135 21.1044)"
          />
        </clipPath>
        <clipPath id="clip4_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 66.6848 7.90866)"
          />
        </clipPath>
        <clipPath id="clip5_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 65.7786 9.10419)"
          />
        </clipPath>
        <clipPath id="clip6_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 57.8927 19.9089)"
          />
        </clipPath>
        <clipPath id="clip7_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 56.9865 21.1044)"
          />
        </clipPath>
        <clipPath id="clip8_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 13.1304 1.90851)"
          />
        </clipPath>
        <clipPath id="clip9_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 14.0366 3.10403)"
          />
        </clipPath>
        <clipPath id="clip10_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(-0.000311317 1 -1 0 33.0611 48.5773)"
          />
        </clipPath>
        <clipPath id="clip11_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(-0.000311317 1 -1 0 33.1078 50.0773)"
          />
        </clipPath>
        <clipPath id="clip12_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(-0.000311317 1 -1 0 33.0611 34.577)"
          />
        </clipPath>
        <clipPath id="clip13_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(-0.000311317 1 -1 0 33.1078 36.077)"
          />
        </clipPath>
        <clipPath id="clip14_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 21.9225 13.9088)"
          />
        </clipPath>
        <clipPath id="clip15_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 22.8287 15.1043)"
          />
        </clipPath>
        <clipPath id="clip16_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 59.364 1.90851)"
          />
        </clipPath>
        <clipPath id="clip17_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 58.4578 3.10403)"
          />
        </clipPath>
        <clipPath id="clip18_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(0.000311317 1 1 0 39.4333 48.5773)"
          />
        </clipPath>
        <clipPath id="clip19_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(0.000311317 1 1 0 39.3867 50.0773)"
          />
        </clipPath>
        <clipPath id="clip20_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(0.000311317 1 1 0 39.4333 34.577)"
          />
        </clipPath>
        <clipPath id="clip21_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(0.000311317 1 1 0 39.3867 36.077)"
          />
        </clipPath>
        <clipPath id="clip22_828_55410">
          <rect
            width="11.8462"
            height="3.40566"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 50.5719 13.9088)"
          />
        </clipPath>
        <clipPath id="clip23_828_55410">
          <rect
            width="9.34615"
            height="3.5"
            fill="white"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 49.6657 15.1043)"
          />
        </clipPath>
      </defs>
    </>
  );
}
